import {
  CREATE_SBF,
  DIRECT_STRATEGY_MANAGEMENT,
  NO_SBF,
  PHASE_NAME_VAL_PAIRS,
  SCOPE_LEVEL_GLOBAL_AFTERMARKET,
  SCOPE_LEVEL_GLOBAL_PRODUCTION,
  SCOPE_LEVEL_UNITORUNITGROUP,
  SMALL_BUSINESS_FORM,
  SOURCING_PROCESS,
  SRO_SBM_PROP_NAME,
  SRO_SBM_USER_ID_PROP_NAME,
  STRATEGY_STATUS_CANCELED,
  STRATEGY_STATUS_DRAFT
} from './AppConstants';
import {
  getFormattedUserNameWithFallback,
  getFormattedUserNameWithId
} from './UserLogin';
import { getEnvVar } from '../utils/getEnvVar';
import dayjs from 'dayjs';
import {
  Alert,
  Badge,
  Box,
  Button,
  Chip,
  Grid,
  Link,
  Typography
} from '@mui/material';
import * as React from 'react';
import {
  SDF_CREATE_CRITICAL_WARNING_MESSAGE_DESCRIPTION,
  SDF_CREATE_WARNING_MESSAGE_HEADER
} from './Messages';
import { getAERatingMap, getSuppliersRiskRatingMap } from './APIHelper';
import { fetchJsonWithAuth } from './fetch-json.util';

export function addPropAndValue(obj, prop, val) {
  obj[prop] = val;
}
export function addPropAndValueIfPresentAdd(obj, prop, val) {
  let tmpVal = getValueIfPresentElseZero(val);

  if (prop in obj) obj[prop] += tmpVal;
  else obj[prop] = tmpVal;
}

export function isCommentsEmptyOrSame(comments, supplier) {
  return (
    !comments ||
    comments.trim() === '' ||
    supplier?.comments?.trim() === comments?.trim()
  );
}

export function ignoreCaseSearch(a, b) {
  return a?.localeCompare(b, undefined, {
    sensitivity: 'accent'
  });
}

export function addToSelectedList(
  list,
  stringtoAdd,
  heading,
  donotTrimLastCharFromStringtoAdd
) {
  let item = {};

  if (stringtoAdd && stringtoAdd.length > 0) {
    item = {
      parent: heading
    };
    addPropAndValue(item, 'children', [
      donotTrimLastCharFromStringtoAdd
        ? stringtoAdd
        : stringtoAdd.substring(0, stringtoAdd.length - 1)
    ]);
  }
  list.push(item);
}

export function formatAmountWithCommas(amount, doRound, notAvailableString) {
  if (amount) {
    let x = doRound ? Math.round(amount) : amount;

    return '$' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else return notAvailableString ?? '$0';
}

export function checkedScope(selectedData, level) {
  let newSelectedParent = [];
  let newSelectedChild = [];

  if (level === SCOPE_LEVEL_UNITORUNITGROUP) {
    selectedData?.forEach((record) => {
      //Unit Group is selected
      if (record.checked) newSelectedParent.push(record.code);
      //Unit is selected
      else
        record.children?.forEach(
          (child) => child.checked && newSelectedChild.push(child.code)
        );
    });
  }

  return {
    newSelectedParent: newSelectedParent,
    newSelectedChild: newSelectedChild
  };
}

export function paintStrategyHeader(
  header,
  statusState,
  lastUpdatedBy,
  strategyInformation
) {
  return (
    <>
      <h2>
        {header}
        {printStrategyPhaseAndStatusBadge(strategyInformation)}
      </h2>
      <h6>
        Last updated on{' '}
        {strategyInformation &&
          dayjs(strategyInformation.updatedOn).format('DD-MMM-YYYY')}{' '}
        by {lastUpdatedBy}
      </h6>
    </>
  );
}

export function paintSaveAndNextButton(showSaveAndNextButton) {
  return (
    showSaveAndNextButton && (
      <div>
        <Button variant="primary" type="submit" value="saveNext" sx={{ mt: 8 }}>
          Save & Next
        </Button>
      </div>
    )
  );
}

export function getOwnerObj(userId, formattedName) {
  let upCaseUserId = userId ? userId.toUpperCase() : '';

  return {
    value: upCaseUserId,
    label: formattedName ? formattedName + ' - ' + upCaseUserId : ''
  };
}

export function getUserObj(userInfo, userId) {
  return {
    value: userId.toUpperCase(),
    label: getFormattedUserNameWithId(userInfo, userId)
  };
}

export function checkedMgcs(data, commodity, major) {
  let selectedMgcs = [];
  let checkedStatusList = [];

  if (data && data.length > 0) {
    data.forEach((parent) => {
      checkedStatusList.push(parent.checked);
      if (parent.checked) {
        //Minor is Selected EX: D010101
        selectedMgcs.push(getMinimalMgcObj(commodity, major, parent.code));
      } else if (parent.children) {
        //Segment is selected EX: D01010101
        parent.children.forEach((child) => {
          if (child.checked)
            selectedMgcs.push(
              getMinimalMgcObj(commodity, major, parent.code, child.code)
            );
        });
      }
    });
    //when all Minors are selected Strategy will be saved on Major Level EX: D0101
    if (checkedStatusList.every(Boolean)) selectedMgcs = [];
  }
  if (selectedMgcs.length === 0)
    selectedMgcs.push(getMinimalMgcObj(commodity, major));

  return selectedMgcs;
}

function getMinimalMgcObj(commodity, major, minor, segment) {
  let selectedMgc = {
    commodity: commodity,
    major: major
  };

  if (minor) addPropAndValue(selectedMgc, 'minor', minor);
  if (segment) addPropAndValue(selectedMgc, 'segment', segment);
  return selectedMgc;
}

export function getUnitGropAndUnitsList(scope) {
  let list = [];

  if (scope && scope.level === SCOPE_LEVEL_UNITORUNITGROUP) {
    scope.unitGroups?.map((item) => list.push(item?.name));
    scope.units?.map((item) => list.push(item?.name));
  }
  return list;
}

export const openLink = (url, e, windowName) => {
  e.preventDefault();
  window.open(url, windowName || '_blank').focus();
};

export function getUserName(ownerId, userMap, donotAppendUserId) {
  let upCaseId = ownerId.toUpperCase();

  return donotAppendUserId
    ? getFormattedUserNameWithFallback(userMap?.get(upCaseId), upCaseId)
    : getFormattedUserNameWithId(userMap?.get(upCaseId), upCaseId);
}
export async function populateRiskRatingBySupplierNumber(splrNumber) {
  if (splrNumber) {
    const map = await getSuppliersRiskRatingMap(splrNumber);

    return map.get(splrNumber);
  }
}
export async function populateAERatingBySupplierNumber(splrNumber) {
  if (splrNumber) {
    const map = await getAERatingMap(splrNumber);

    return map.get(splrNumber);
  }
}
export function getSuppliersWithStatusPopulated(
  activeSupplierMap,
  supplierObj
) {
  if (supplierObj && supplierObj.length > 0) {
    supplierObj.forEach((obj) => {
      let txt = activeSupplierMap && activeSupplierMap.get(obj.supplierNumber);

      addPropAndValue(obj, 'activeSupplier', txt ? txt : '');
    });

    return supplierObj;
  }
}

export async function populateSuppliersRiskRatingMap(
  supplierNumbers,
  setSupplierRiskRatingMap,
  commonProps
) {
  if (supplierNumbers?.length > 0) {
    commonProps.incrementAPIInProgress();

    try {
      const map = await getSuppliersRiskRatingMap(supplierNumbers);
      setSupplierRiskRatingMap(map);
    } catch (error) {
      commonProps.setStatusErrorMsg(
        "Couldn't load the Supplier Rating Details. Please try again.",
        error
      );
    } finally {
      commonProps.decrementAPIInProgress();
    }
  }
}

export function getSuppliersWithSroSbmPopulated(sroSbmMap, suppliers) {
  if (suppliers?.length > 0 && sroSbmMap) {
    const isMap = sroSbmMap instanceof Map;

    suppliers.forEach((obj) => {
      const userObj = isMap
        ? sroSbmMap.get(obj.supplierNumber)
        : sroSbmMap[obj.supplierNumber];

      if (userObj) {
        const sroName = getFormattedUserNameWithFallback(
          userObj,
          userObj.userId
        );

        addPropAndValue(obj, SRO_SBM_PROP_NAME, sroName);
        addPropAndValue(obj, SRO_SBM_USER_ID_PROP_NAME, userObj.userId);
      }
    });
    return suppliers;
  }
}

export function handlePromiseResult(
  result,
  propName,
  errorMsg,
  splrObj,
  commonProps
) {
  if (result.status === 'rejected') {
    commonProps.setStatusErrorMsg(errorMsg);
  } else {
    splrObj[propName] =
      propName === 'sdis'
        ? result.value.get(splrObj.supplierNumber)
        : result.value;
  }
}

export function isScopeAnyGlobalType(scopeType) {
  return (
    SCOPE_LEVEL_GLOBAL_PRODUCTION === scopeType ||
    SCOPE_LEVEL_GLOBAL_AFTERMARKET === scopeType
  );
}

export function findUSIndicatorNew(scope, scopeUSIndicatorMap) {
  let flag = false;

  if (isScopeAnyGlobalType(scope.level)) {
    flag = scopeUSIndicatorMap.get(scope.level);
  } else if (scope.level === SCOPE_LEVEL_UNITORUNITGROUP) {
    scope.unitGroups?.forEach((unitGroup) => {
      if (scopeUSIndicatorMap.get(unitGroup)) flag = true;
    });

    !flag &&
      scope.units?.forEach((unit) => {
        if (scopeUSIndicatorMap.get(unit)) flag = true;
      });
  }
  return flag;
}

export function makeSDFLink(e, strategyInformation, url) {
  e.preventDefault();

  let path = getSDFPath(strategyInformation, url);
  window.open(
    path,
    '',
    'width=1500px,height=750px,menubar=yes,resizable=yes, scrollbars=yes'
  );
}

function getSDFPath(strategyInformation, url) {
  return (
    url +
    '/' +
    DIRECT_STRATEGY_MANAGEMENT +
    '/' +
    strategyInformation.strategyId
  );
}

export function getContactUsLink(userId, comments) {
  return String.raw`${getEnvVar('VITE_CONTACT_US_URL')}&USERID=${userId}&COMMENTS=${comments || ''}`;
}

export function paintJustUnitScopes(units) {
  return (units || [])
    .sort((a, b) => a.code.localeCompare(b.code))
    .map((scope) => paintScopeDesc(scope.code, scope.name));
}
export function paintScopeDesc(
  code,
  desc,
  showAsInactive,
  badge,
  donotShowCode
) {
  let text = donotShowCode ? desc : `${desc} - ${code}`;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography sx={showAsInactive ? { color: 'text.disabled' } : {}}>
        {text}
      </Typography>
      {badge && (
        <Box sx={{ pl: 3 }}>
          <Badge type="bold" variant="info">
            {badge}
          </Badge>
        </Box>
      )}
    </Box>
  );
}
export function paintMGCs(strategyInformation) {
  return strategyInformation.decorated?.mgcs?.sort().map((mgc) => {
    const index = mgc.indexOf(' - ');
    const code = mgc.substring(0, index);
    const desc = mgc.substring(index + 3);

    return paintMGCCodeDesc(code, desc);
  });
}

export function paintMGCCodeDesc(code, desc, showAsInactive, badge) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {showAsInactive ? (
        <>
          <Typography sx={{ color: 'text.disabled' }}>
            {code}&nbsp;-&nbsp;
          </Typography>
          <Typography sx={{ color: 'text.disabled' }}>{desc}</Typography>
        </>
      ) : (
        <>
          <Typography sx={{ color: 'text.secondary' }}>
            {code}&nbsp;-&nbsp;
          </Typography>
          <Typography>{desc}</Typography>
        </>
      )}
      {badge && (
        <Box sx={{ pl: 3 }}>
          <Badge type="bold" variant="info">
            {badge}
          </Badge>
        </Box>
      )}
    </Box>
  );
}

export function isUploadValid(file, setStatusErrorMsg) {
  if (!file || file?.length === 0) {
    setStatusErrorMsg('Please select a file to upload');
    return false;
  } else return true;
}

export const PhaseBadges = ({ file }) => {
  return (
    <Grid container gap={2}>
      {PHASE_NAME_VAL_PAIRS.map((phase) => (
        <Chip
          key={phase.value}
          variant={'badge'}
          color={
            phase.value === 'phase5'
              ? 'success'
              : phase.value === 'phase4'
                ? 'informational'
                : phase.value === 'sourcingProcess'
                  ? 'accent'
                  : 'neutral'
          }
          label={phase.name}
          sx={{ display: file[phase.value] ? 'flex' : 'none' }}
        ></Chip>
      ))}
    </Grid>
  );
};

export const saveFileUpload = (
  e,
  entity,
  entityToAdd,
  description,
  apiUrl,
  dispatch,
  clearComponent,
  selectedPhases,
  commonProps,
  enqueueToast
) => {
  e.preventDefault();

  if (isUploadValid(entityToAdd, commonProps.setStatusErrorMsg)) {
    commonProps?.clearAllMessages();
    const data = {
      visibleOnSummary: true,
      description: description,
      ...transformPhasesForPersistence(selectedPhases)
    };
    const jsonString = JSON.stringify(data);
    const jsonBlob = new Blob([jsonString], { type: 'application/json' });
    const formData = new FormData();

    formData.append(entity, jsonBlob, 'data.json');
    formData.append('file', entityToAdd[0]);

    commonProps.incrementAPIInProgress();
    fetchJsonWithAuth(apiUrl, {
      method: 'POST',
      body: formData
    })
      .then((response) => {
        const { fileName, attachment } = response.json;

        if (
          (fileName || attachment) &&
          (response.meta.status === 200 || response.meta.status === 201)
        ) {
          if (enqueueToast) {
            enqueueToast({
              variant: 'success',
              message: `${
                entity.charAt(0).toUpperCase() + entity.slice(1)
              } has been successfully added.`
            });
          } else {
            commonProps.setStatusSuccessMsg(
              `${
                entity.charAt(0).toUpperCase() + entity.slice(1)
              } has been successfully added.`
            );
          }
          dispatch({ type: 'add', payload: response.json });
          clearComponent();
        } else if (response.json?.attachmentExists) {
          commonProps.setStatusErrorMsg(response.json.attachmentExists);
        } else {
          commonProps.setStatusErrorMsg(
            `Couldn't add the ${
              entity.charAt(0).toUpperCase() + entity.slice(1)
            }. Please try again.`,
            response.json.message
          );
        }
      })
      .catch((error) => {
        commonProps.setStatusErrorMsg(
          `Couldn't add the ${
            entity.charAt(0).toUpperCase() + entity.slice(1)
          }. Please try again.`,
          error
        );
      })
      .finally(() => commonProps.decrementAPIInProgress());
  }
};

export const transformPhasesForPersistence = (selectedPhases) => {
  const phaseObject = {};

  PHASE_NAME_VAL_PAIRS.forEach((phase) => {
    phaseObject[phase.value] = selectedPhases?.includes(phase.name);
  });

  return phaseObject;
};

export const transformPhasesFromAPIResponse = (selectedPhasesObj) => {
  const phaseObject = [];

  PHASE_NAME_VAL_PAIRS.forEach((phase) => {
    if (selectedPhasesObj[phase.value]) phaseObject.push(phase.name);
  });

  return phaseObject;
};

export function getBadgeVariant(phase) {
  if (phase === 'Phase 1' || phase === 'Phase 2' || phase === 'Phase 3')
    return 'info';
  else if (phase === SOURCING_PROCESS) return 'default';
  else return 'success';
}

export function getBadgeVariantByStatus(status) {
  if (status === 'Active') return 'success';
  else return 'info';
}

export function printStrategyPhaseAndStatusBadge(strategy) {
  if (strategy) {
    const phase = `Phase ${strategy.currentPhase}`;
    const msg = `${strategy.status} - ${phase}`;

    return printBadge(strategy.status, msg, 'status');
  }
}

function printBadge(value, msg, type = 'phase') {
  const isCanceled = msg === STRATEGY_STATUS_CANCELED;
  const variant = isCanceled
    ? 'error'
    : type === 'status'
      ? getBadgeVariantByStatus(value)
      : getBadgeVariant(value);
  const badgeType = isCanceled
    ? 'bold'
    : type === 'phase' && value === 'Phase 5'
      ? 'bold'
      : 'default';

  return (
    <Chip color={variant} variant={'badge'} type={badgeType}>
      {isCanceled && <fuel-icon name="delete" />}
      {msg}
    </Chip>
  );
}

export function displaySDFTitleInfo(hasUSScope, strategyInformation) {
  return hasUSScope || strategyInformation.sdsFormId > 0 ? (
    <Typography variant="h3">{SMALL_BUSINESS_FORM}</Typography>
  ) : (
    <></>
  );
}

export function getMissingSDFDisplay(
  hasUSScope,
  strategyInformation,
  okToPublish
) {
  return (
    strategyInformation &&
    hasUSScope &&
    strategyInformation.sdsFormId === null && (
      <Box>
        <Alert severity={okToPublish ? 'warning' : 'error'} aria-atomic="true">
          <Typography sx={{ mt: 1 }}>
            {SDF_CREATE_CRITICAL_WARNING_MESSAGE_DESCRIPTION}
            <br />
            <br />
            {SDF_CREATE_WARNING_MESSAGE_HEADER}
            <br />
            <br />
            <Link
              href={getSDFPath(
                strategyInformation,
                getEnvVar('VITE_CREATE_SDFORM_URL')
              )}
              onClick={(e) =>
                makeSDFLink(
                  e,
                  strategyInformation,
                  getEnvVar('VITE_CREATE_SDFORM_URL')
                )
              }
            >
              {CREATE_SBF}
            </Link>
          </Typography>
        </Alert>
      </Box>
    )
  );
}

export function displaySDFInfo(
  hasUSScope,
  strategyInformation,
  addMargin,
  createSDF,
  getMissingSDFDisplay
) {
  return hasUSScope || strategyInformation.sdsFormId > 0 ? (
    <Typography sx={addMargin ? { mt: 1 } : {}}>
      {strategyInformation.sdsFormId > 0 ? (
        <Link
          variant="linkExternal"
          href={getSDFPath(
            strategyInformation,
            getEnvVar('VITE_VIEW_SDFORM_URL') +
              '/' +
              strategyInformation.sdsFormId
          )}
          onClick={(e) =>
            makeSDFLink(
              e,
              strategyInformation,
              getEnvVar('VITE_VIEW_SDFORM_URL') +
                '/' +
                strategyInformation.sdsFormId
            )
          }
        >
          {strategyInformation.sdsFormId}
        </Link>
      ) : hasUSScope && createSDF ? (
        getMissingSDFDisplay()
      ) : (
        NO_SBF
      )}
    </Typography>
  ) : (
    <></>
  );
}

export function getScope(scopeLevel, selectedScopeUnits) {
  let { newSelectedParent, newSelectedChild } = checkedScope(
    selectedScopeUnits,
    scopeLevel
  );
  return {
    level: scopeLevel,
    unitGroups: newSelectedParent,
    units: newSelectedChild
  };
}

export function findUnitCodeAndName(selectedData) {
  let newSelectedChildWithName = [];

  selectedData?.forEach((record) => {
    record.children?.forEach((child) => {
      if (child.checked) {
        let tempObj = {
          code: child.code,
          name: child.name
        };

        if (tempObj) newSelectedChildWithName.push(tempObj);
      }
    });
  });

  return newSelectedChildWithName;
}

export function getSpendErrorMsg(strategyInformation, forMGC) {
  let c1 = strategyInformation?.invoiceSpend?.errorStatus;
  let c2 = strategyInformation?.forecastSpend?.errorStatus;
  let msg = null;
  let mgcLabel = forMGC ? 'MGC' : '';

  if (c1 && c2) msg = `Could not fetch the ${mgcLabel} spend info`;
  else if (c1) msg = `Could not retrieve the ${mgcLabel} invoice spend info`;
  else if (c2) msg = `Could not retrieve the ${mgcLabel} forecast spend info`;

  return msg;
}
export function findSupplier(strategyInformation, supplierNumber) {
  let found = strategyInformation?.suppliers?.find(
    (splr) => splr.supplierNumber === supplierNumber
  );

  if (!found) {
    found = strategyInformation?.nonStrategicSuppliers?.find(
      (splr) => splr.supplierNumber === supplierNumber
    );

    if (!found)
      found = strategyInformation?.nonStrategySupplierList?.find(
        (splr) => splr.supplierNumber === supplierNumber
      );
  }

  return found;
}

export function getValueIfPresentElseZero(val) {
  return val || 0;
}

export const utf8SafeDecode = (value) => {
  try {
    return new TextDecoder().decode(
      Uint8Array.from(value, (c) => c.charCodeAt(0))
    );
  } catch (_) {
    return value;
  }
};

export const sortedTemplateList = (unsortedList = []) => {
  const itemsInSourcingProcess = [];
  const itemsNotInSourcingProcess = [];

  unsortedList.forEach((origItem) => {
    const item = origItem;
    // assign the lowest phase number present (Phase 1 preferred)
    let assignedPhase = Number.MAX_SAFE_INTEGER;
    for (let i = 1; i <= 5; i++) {
      if (item[`phase${i}`]) {
        assignedPhase = i;
        break; // first (lowest) phase found
      }
    }

    // if no phase flags are present, set to Infinity so it sorts last
    item.phase =
      assignedPhase === Number.MAX_SAFE_INTEGER ? Infinity : assignedPhase;

    if (item.sourcingProcess) itemsInSourcingProcess.push(item);
    else itemsNotInSourcingProcess.push(item);
  });

  const phaseComparator = (a, b) => {
    const pa = typeof a.phase === 'number' ? a.phase : Infinity;
    const pb = typeof b.phase === 'number' ? b.phase : Infinity;
    if (pa === pb) {
      const aName = a.displayName || a.name || a.fileName || '';
      const bName = b.displayName || b.name || b.fileName || '';
      return aName.localeCompare(bName);
    }
    return pa - pb;
  };

  itemsInSourcingProcess.sort(phaseComparator);
  itemsNotInSourcingProcess.sort(phaseComparator);

  return [...itemsInSourcingProcess, ...itemsNotInSourcingProcess];
};

export function isEventSourceTrusted(event) {
  try {
    const originUrl = new URL(event.origin);
    const hostname = originUrl.hostname.toLowerCase();
    const isDeereDomain =
      hostname === 'deere.com' || hostname.endsWith('.deere.com');
    const isExpectedHost =
      hostname === 'jdsn-sdf.deere.com' || hostname.startsWith('jdsn-sdf.');

    return isDeereDomain && isExpectedHost;
  } catch (_) {
    // Ignore invalid origins
  }

  return false;
}
